import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Imobiliaria } from "@/integrations/supabase/types";
import { MOCK_IMOBILIARIA } from "@/data/mockData";
import { useTenant } from "@/hooks/useTenant";

const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === "true";

/**
 * Hook para buscar dados da imobiliária por subdomínio
 * @param subdominio - Identificador único da imobiliária (ex: 'desordibroker')
 */
export function useImobiliaria(subdominio: string) {
  const tenant = useTenant();
  return useQuery({
    queryKey: ["imobiliaria", tenant.subdominio],
    queryFn: async (): Promise<Imobiliaria> => {
      // Modo mock: retorna dados mockados imediatamente
      if (USE_MOCK_DATA) {
        return MOCK_IMOBILIARIA;
      }

      // Modo real: busca da view pública do HouseBit
      const { data, error } = await supabase
        .from("imobiliarias_public")
        .select("*")
        .eq("subdominio", tenant.subdominio)
        .single();

      if (error) throw error;
      if (!data) throw new Error("Imobiliária não encontrada");

      return data;
    },
    enabled: !!tenant.subdominio,
    staleTime: 1000 * 60 * 10, // Cache por 10 minutos
  });
}
